import { useHomeDataBase } from "../../SHARED/hooks/useHomeDataBase";
import { LAW_FIRM_HOME_URL_BUILDERS } from "../lawFirmHomeDataConfig";

/**
 * Law-firm home drafts, activity, and indemnity data via shared home base.
 */
export function useLawFirmHomeData(lawFirmId, userId, lawfirmIdFromStore) {
  return useHomeDataBase({
    userId,
    scopeId: lawFirmId,
    enabled: Boolean(lawFirmId),
    urlBuilders: LAW_FIRM_HOME_URL_BUILDERS,
    appendIndemnityFormFields: (form, { userId: uid, scopeId }) => {
      const lfId = scopeId ?? lawfirmIdFromStore;
      if (lfId) form.append("lawfirm_id", String(lfId));
      if (uid) form.append("requester_id", String(uid));
    },
  });
}
